import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { DollarSign, Mail, ListChecks, FolderArchive } from 'lucide-react';
import ComisionesLideresTab from './ComisionesLideresTab';
import ReporteBITab from './ReporteBITab';
import ComunicacionesPersonalTab from './ComunicacionesPersonalTab';
import ControlesRRHHTab from './ControlesRRHHTab';
import RepositorioDocumentalTab from './RepositorioDocumentalTab';

/**
 * Tab "RRHH" en Finanzas con 4 sub-tabs:
 * 1. Comisión Líderes (incluye Reporte BI al final)
 * 2. Comunicaciones al Personal
 * 3. Controles (Vencimientos PF + Matriz Maestra de Novedades)
 * 4. Repositorio Documental (Carpeta Digital del Funcionario)
 */
export default function RRHHTab() {
  return (
    <Tabs defaultValue="comisiones" className="w-full" data-testid="rrhh-tabs">
      <TabsList className="bg-slate-100 p-1 mb-4 flex flex-wrap h-auto">
        <TabsTrigger value="comisiones" className="text-xs gap-1.5" data-testid="rrhh-tab-comisiones">
          <DollarSign className="w-3.5 h-3.5" /> Comisión Líderes
        </TabsTrigger>
        <TabsTrigger value="comunicaciones" className="text-xs gap-1.5" data-testid="rrhh-tab-comunicaciones">
          <Mail className="w-3.5 h-3.5" /> Comunicaciones al Personal
        </TabsTrigger>
        <TabsTrigger value="controles" className="text-xs gap-1.5" data-testid="rrhh-tab-controles">
          <ListChecks className="w-3.5 h-3.5" /> Controles
        </TabsTrigger>
        <TabsTrigger value="repositorio" className="text-xs gap-1.5" data-testid="rrhh-tab-repositorio">
          <FolderArchive className="w-3.5 h-3.5" /> Repositorio Documental
        </TabsTrigger>
      </TabsList>

      {/* Comisión Líderes (con Reporte BI en la parte baja) */}
      <TabsContent value="comisiones" className="space-y-6">
        <ComisionesLideresTab />
        <div className="border-t border-slate-200 pt-4">
          <ReporteBITab />
        </div>
      </TabsContent>

      <TabsContent value="comunicaciones">
        <ComunicacionesPersonalTab />
      </TabsContent>

      <TabsContent value="controles">
        <ControlesRRHHTab />
      </TabsContent>

      <TabsContent value="repositorio">
        <RepositorioDocumentalTab />
      </TabsContent>
    </Tabs>
  );
}
